export default {
  global: {
    '~NOMBRE_SISTEMA~': 'IPCOM VORTEX',
    '~FIRMA~': 'IPCOM VORTEX, ©2018.',
    '~ESPANOL~': 'Espanhol',
    '~PORTUGUES~': 'Português',
    '~ITALIANO~': 'Italiano',
    '~FRANCES~': 'Francês',
    '~INGLES~': 'Inglês',
    '~IDIOMA~': 'Idioma',
    '~IDIOMA2~': 'Idioma de Reconhecimento',
    '~MENU~': 'Menu',
    '~TOTALES~': 'Totais',
    '~FINALIZADO~': 'A campanha foi salva',
    '~LOADING~': 'Carregando',
    '~USUARIOS~': 'Usuários',
    '~EDITAR~': 'Editar',
    '~DUPLICAR~': 'Duplicar',
    '~REFRESCAR~': 'Atualizar',
    '~DESACTIVAR~': 'Desativar',
    '~ACTIVAR~': 'Ativar',
    '~AYUDA~': 'Ajuda',
    '~AYUDA_ACTIVADA~': 'Ajudas Ativadas',
    '~AYUDA_DESACTIVADA~': 'Ajudas Inativas',
    '~ACTIVADAS~': 'Mensagens de ajuda ativados',
    '~DESACTIVADAS~': 'Mensagens de ajuda desativados',
    '~CONFIRMAR_AYUDA~': 'Deseja desativar as mensagens de ajuda?',
    '~ACEPTAR~': 'Aceitar',
    '~CONECTANDO~': 'Conectando',
    '~OPCIONES~': 'Opções',
    '~ELIMINAR~': 'Excluir',
    '~REMOVER~': 'Remover',
    '~CANCELAR~': 'Cancelar',
    '~OMITIR~': 'Omitir',
    '~EXPANDIR~': 'Expandir',
    '~AGREGAR~': 'Adicionar',
    '~AVATAR~': 'Avatar',
    '~CONFIGURACION~': 'Configuração',
    '~HOY~': 'Hoje',
    '~SEMANA~': 'Semana',
    '~PERSONALIZAR~': 'Personalizar',
    '~ESTUDIANTE~': 'Estudante',
    '~MASCULINO~': 'Masculino',
    '~FEMENINO~': 'Feminino',
    '~VOLVER~': 'Voltar',
    '~SIGUIENTE~': 'Seguinte',
    '~ANTERIOR~': 'Anterior',
    '~GUARDAR~': 'Salvar',
    '~CERRAR~': 'Fechar',
    '~VALIDA_POR~': 'Válida por',
    '~FAMILIA~': 'Famílias',
    '~AUTORIZADO~': 'Autorizado',
    '~AMIGOS~': 'Amigos',
    '~PERSONAS~': 'Pessoas',
    '~TOKEN~': 'Token',
    '~TOKENS~': 'Tokens',
    '~VEHICULOS~': 'Veículos',
    '~RETIRADAS_AUTORIZADO~': 'Retiradas pelo Autorizado',
    '~HORAS_RETIRADA~': 'Horas de Retirada',
    '~CAMBIAR_CLAVE~': 'Trocar Senha',
    '~EDITAR_PERFIL~': 'Editar Perfil',
    '~HOME~': 'Início',
    '~COFIGURACION~': 'Configuração',
    '~MENU_PRINCIPAL~': 'Menu Principal',
    '~FECHA~': 'Data',
    '~ALUMNOS~': 'Alunos',
    '~INFORMACION~': 'Informação',
    '~FOTO_PERFIL~': 'Foto de Perfil',
    '~FOTO_VEHICULO~': 'Foto do Veículo',
    '~TOMAR_FOTO~': 'Tirar Foto',
    '~SUBIR_ARCHIVO~': 'Subir Arquivo',
    '~REGISTROS~': 'Registros',
    '~ZOOM~': 'Zoom',
    '~DETALLES~': 'Detalhes',
    '~BUSCADOR~': 'Buscar',
    '~SALIR~': 'Sair',
    '~TIPO~': 'Tipo',
    '~CONTINUAR~': 'Continuar',
    '~CONFIRMAR~': 'Confirmar',
    '~FINALIZAR~': 'Finalizar',
    '~ALERTA~': '¡Alerta!',
    '~TITULO~': 'Título',
    '~VOZ~': 'Voz',
    '~NOTA~': 'Nota',
    '~ACCION~': 'Ação',
    '~ACCIONES~': 'Ações',
    '~FILAS~': 'Filas',
    '~DE~': 'De',
    '~A~': 'A',
    '~TEXTO~': 'Texto',
    '~NUMERO~': 'Número',
    '~NEXT_STEP~': 'Passo Seguinte',
    '~CONFIRMAR_BORRAR~': 'Tem certeza que deseja eliminar?',
    '~CONFIRMAR_REMOVER~': 'Tem certeza que deseja remover?',
    '~CONFIRMAR_PARAR~': 'Tem certeza que deseja parar a campanha?',
    '~MENSAJE_REFRESCAR~':
      'Advertência! A informação nesta tabela não está atualizada, <br /> por favor dê um click em "Atualizar"',
    relation: {
      '~NOMBRE~': 'Relação',
      options: {
        '~PADRE~': 'Pai',
        '~HIJO~': 'Filho',
        '~RELATIVO~': 'Familiar',
        '~EMPLEADO~': 'Empregado'
      }
    }
  },
  message: {
    '~CORREO_TOMADO~': 'O correio electrônico já está sendo usado'
  },
  login: {
    '~TITULO~': 'Autenticação',
    '~USUARIO~': 'Usuário',
    '~CLAVE~': 'Senha',
    '~NUEVA~': 'Nova Senha',
    '~CORREO~': 'Correio',
    '~ENTRAR~': 'Entrar',
    '~OLVIDO~': 'Esqueceu a Senha?',
    '~RECORDARME~': 'Lembrar de mim',
    '~CONTACTO~': 'Contatar Webmaster',
    '~RECUPERAR~': 'Recuperar Senha',
    '~MENSAJE~': 'Enviamos um correio com as instruções de recuperação',
    '~RECUPERACION_OK~': 'Sua senha foi modificada com sucesso',
    '~ENVIAR~': 'Enviar',
    '~VOLVER~': 'Voltar',
    '~RESETEAR~': 'Reset da Senha',
    '~VERIFICAR~': 'Verificar Senha',
    '~BIENVENIDO~': 'Bem-vindo ao Sistema IPCOM',
    '~NO_AUTORIZADO~': 'Desculpe! O correio ou a senha estão incorretos',
    '~NO_AUTENTICADO~': 'Desculpe! Você não encontra-se autenticado',
    '~EXITOSO~': 'Início de sessão bem sucedido',
    '~NO_USUARIO~': 'Erro! Este usuário não existe'
  },
  menu: {
    '~INICIO~': 'Início',
    '~TABLERO~': 'Painel',
    '~CAMPAGNA~': 'Campanhas',
    '~BASE_DATOS~': 'Bases de Dados',
    '~ORGANIZACION~': 'Organizações',
    '~USUARIOS~': 'Usuários',
    '~REPORTES~': 'Relatórios',
    '~CONFIGURACION~': 'Configuração',
    '~CAMPAGNA_ABIERTA~': 'Campanhas abertas'
  },
  campaign: {
    '~CAMPAGNA~': 'Campanha',
    '~IDIOMA~': 'Idioma',
    '~EDITAR~': 'Editar Campanha',
    '~INSERTAR~': 'Nova Campanha',
    '~NOMBRE~': 'Nome de Campanha',
    '~CAMPAGNA_ABIERTA~': 'Mode de campanha aberta',
    '~CERRAR~': 'Fechar campanha',
    '~TTS_MENSAJE2~': 'Mensagem TTS anterior',
    '~GUARDANDO~': 'Salvando campanha',
    '~SUSCRIPTORES~': 'Base de Dados Subscritos',
    '~PASO~': 'Passo',
    '~ESTADO~': 'Estado',
    '~ARBOL~': 'Árvore de Navegação',
    '~TRANSICION~': 'Transição',
    '~DIGITOS~': 'Dígitos',
    '~VARIABLE_NOMBRE~': 'Nome Variável',
    '~TIEMPO~': 'Tempo',
    '~COMANDO_VOZ~': 'Voz',
    '~BASE_DATOS~': 'Base de Dados',
    '~LLAMADAS~': 'Ligações simultâneas',
    '~INTERACCION~': 'Interação',
    '~TASA_CONTACTO~': 'Percentual de contatação',
    '~PREFIJO~': 'Prefixo de Discagem',
    '~REJECT_CODES~': 'Códigos de Rejeição RDSI',
    '~GRUPOS_RUTAS~': 'Grupos de Rotas',
    '~IDENTIFICADOR~': 'ID de Ligação',
    '~ID_CLIENTE~': 'ID Cliente',
    '~TIEMPO_ESPERA~': 'Tempo de Espera',
    '~TIEMPO_DIGITOS~': 'Tempo de Espera de Dígito',
    '~TIEMPO_REINTENTO~': 'Tempo de Nova Tentativa',
    '~MAQUINA_RESPUESTA~': 'Detecção de caixa postal',
    '~MAQUINA_RESPUESTA_TOOLTIP~': 'Detecta automaticamente secretárias eletrônicas (AMD) e caixa postal.',
    '~MAQUINA_COLGAR~': 'Máquina de Detecção de Respostas Desligar',
    '~MAQUINA_COLGAR_TOOLTIP~': 'Encerra a chamada ao detectar caixa postal.',
    '~TITULO~': 'Título',
    '~TODAS~': 'Todas',
    '~TTS_MENSAJE~': 'Mensagem TTS',
    '~PREFIJO_ARCHIVO~': 'Prefixo de Arquivo',
    '~MAXIMA_LONGITUD~': 'Máxima Longitude',
    '~REPETIR~': 'Repetir',
    '~FINAL~': '# Ao Final',
    '~IMPORTAR~': 'Importar Contatos',
    '~IMPORTAR_CVS~': 'Importar novos registros',
    '~IMPORTAR_DESC~': 'Agora juntaremos as colunas do arquivo carregado com sua lista de Subscritos',
    '~OMITIR_CABECERAS~': 'Sem Cabeçalhos',
    '~NUEVA_COLUMNA~': 'Novo nome',
    '~INTENTOS_MAXIMOS~': 'Máximo de Tentativas',
    '~PROXIMO_REINTENTO~': 'PRI',
    '~INTENTOS_ALCANZADOS~': 'Número máximo de tentativas alcançadas',
    '~LLAMADAS_ALCANZADOS~': 'Número máximo de ligações alcançadas',
    '~INTENTOS_MAX~': 'Máx. Tentativas',
    '~MAXIMO_ALCANZADO~': 'Limite máximo alcançado',
    '~CANALES_MAXIMOS~': 'Canais Máximos',
    '~ZONA_HORARIA~': 'Fuso Horário',
    '~COLGAR_NO_RESP~': 'Desligar se não tem resposta',
    '~EXTENSION~': 'Ramal',
    '~MINIMO_HORA~': 'Hora Mínima',
    '~MAXIMO_HORA~': 'Hora Máxima',
    '~SELECCIONAR_FECHA~': 'Selecionar Data',
    '~FECHA_COMIENZO~': 'Data Início',
    '~FECHA_FINAL~': 'Data Final',
    '~FECHA_ERROR~': 'A data de início deve ser anterior que a data final.',
    '~FECHA_CREACION~': 'Data de Criação',
    '~ACTIVAS~': 'Campanhas Ativas',
    '~ULTIMAS~': 'Últimas Campanhas',
    '~BASES_MONITOREADAS~': 'Bases Monitoradas',
    '~NUMEROS~': 'Números',
    '~EN_COLA~': 'Em fila',
    '~MARCADO~': 'Marcado',
    '~CONTACTO~': 'Contato',
    '~VER~': 'Ver',
    '~ACTIVA~': 'Ativo / Máx',
    '~SILENCIO~': 'Silêncio',
    '~REPETICIONES~': 'Número de Repetições',
    '~AUDIO_INVALIDO~': 'Áudio de nova tentativa',
    '~FRASE~': 'Frase',
    '~VARIABLE~': 'Variável',
    '~FORMULA~': 'Fórmula',
    '~GENERACION_TTS~': 'Geração de TTS',
    '~GENERAR_AUDIOS~': 'Sintetizar Áudios',
    '~PROBAR_AUDIO~': 'Provar TTS',
    '~DESCARGAR_TTS~': 'Descarregar TTS',
    '~ARCHIVAR~': 'Arquivar',
    '~OPERADOR~': 'Agente',
    '~AYUDA_VARCOMP~': 'Sintáxe códigos avançados',
    '~VOICES2_NOT_FOUND~': 'Não há vozes para o idioma selecionado.',
    subscriber: {
      '~BD_CREADA~': 'A base de dados foi criada com sucesso'
    },
    sayas: {
      '~NOMBRE~': 'Dizer como',
      options: {
        '~CARACTERES~': 'Caracteres',
        '~NUMERO~': 'Número',
        '~CARDINAL~': 'Cardinal',
        '~ORDINAL~': 'Ordinal',
        '~DIGITOS~': 'Dígitos',
        '~FECHA~': 'Data'
      }
    },
    callerId: {
      '~IDENTIFICADOR~': 'ID de llamada',
      '~TELEFONO~': 'Número telefónico como ID de llamada',
      '~CLIENTE~': 'ID de cliente como ID de llamada',
      '~SUSCRIPTOR~': 'ID de Suscriptor como ID de llamada'
    },
    '~NO_PAREJA~': 'coluna sem par',
    '~NO_CAMPANA~': 'Não existen campanhas registradas',
    '~NO_ACTIVAS~': 'Não existen campanhas ativas',
    '~SIN_RESULTADOS~': 'Nenhuma campanha encontrada com esse critério',
    '~BUSCAR_CAMPANA~': 'Pesquisar por nome ou ID...',
    '~NO_RESULTADO~': 'Não teve resultado na busca',
    formula: {
      '~IGUAL~': 'Igual',
      '~MAYOR~': 'Maior que',
      '~MENOR~': 'Menor que',
      '~MAYOR_IGUAL~': 'Maior ou igual',
      '~MENOR_IGUAL~': 'Menor ou igual',
      '~DISTINTO~': 'Distinto',
      '~REGULAR~': 'Regular',
      '~DEFAULT~': 'Default',
      '~DEFAULT_NAME~': 'Ação por default'
    }
  },
  organization: {
    '~TITULO~': 'Organização',
    '~EDITAR~': 'Editar Organização',
    '~INSERTAR~': 'Nova Organização',
    '~NOMBRE~': 'Nome da Organização',
    '~TELEFONO~': 'Telefone',
    '~NOMBRE_COMPLETO~': 'Nome Completo',
    '~IMAGEN_ERROR~': 'O limite de tamanho foi excedido!',
    '~IMAGEN_MENSAJE~': 'Somente formatos .png e .jpg são permitidos. Tamanho máximo 5mb.',
    '~IMAGEN_TAMANO~': 'O tamanho deve ser 264px / 120px',
    '~TITULO_PROGRAMA~': 'Título do software',
    '~LOGO_PERSONALIZADO~': 'Logotipo personalizado',
    '~SELECCIONADO~': 'Seleção',
    '~NO_ORGANIZATION~': 'Não existen organizações registradas',
    '~PAÍS~': 'País',
    '~CPS_MÁXIMO~': 'CPS máximo',
    '~PROPIA~': 'Próprio',
    '~TELEFONÍA~': 'Telefonia',
    '~Añadir_CPS~': 'Adicionar CPS',
    '~CPS_MÁXIMO_ERROR~': 'O CPS do país não pode exceder o CPS da organização controladora naquele país'
  },
  dialer: {
    '~NOMBRE~': 'Discadores',
    '~CAPACIDAD~': 'Capacidade',
    '~ACTIVOS~': 'Ativos',
    '~NO_MARCADORES~': 'Não há Discadores ativos'
  },
  database: {
    '~TITULO~': 'Base de Dados',
    '~EDITAR~': 'Editar Base de Dados',
    '~INSERTAR~': 'Nova Base de Dados',
    '~NOMBRE~': 'Nome de Base de Dados',
    '~CREADA~': 'Criada',
    '~REGISTROS_DE~': 'Registros de',
    '~ESTADO~': 'Estado',
    '~COLUMNAS~': 'Colunas',
    '~SUSCRIPTORES~': 'Subscritos',
    '~BORRAR_SUBS~': 'Eliminar subscritos que não se encontrem neste novo arquivo',
    '~EDITAR_SUBS~': 'Atualizar variáveis em suscritos existentes',
    '~SUSCRIPTORES_FULL~': 'Subscritos',
    '~NO_DATABASE~': 'Não existem bases de dados registradas',
    '~NO_RESULTADO~': 'Não obteve-se resultado na busca',
    '~VARIABLE_PHONE~': 'Deve existir um campo con nome "phone" para continuar',
    '~VALIDATE_NUMBER~': 'Validar numeração',
    '~COUNTRY~': 'País',
    '~ONLY_CALL_TO_NUMBERS~': 'Disque apenas para números',
    '~DONWLOAD_INVALID_NUMBERS~': 'Deseja baixar o relatório de números inválidos do banco de dados?'
  },
  report: {
    '~TITULO~': 'Relatórios',
    '~EDITAR~': 'Editar Relatório',
    '~INSERTAR~': 'Novo Relatório',
    '~CREADA~': 'Criada',
    '~ESTADO~': 'Estado',
    '~INFORME_RESUMIDO~': 'Relatório Resumido',
    '~INFORME_BASE~': 'Relatório Base',
    '~INFORME_DURACION~': 'Relatório de Duração',
    '~ENCUESTA~': 'Enquete',
    '~CONTESTADA~': 'Atendida',
    '~RESPUESTAS~': 'Respostas',
    '~PROMEDIO_ENCUESTA~': 'Números da Enquete',
    '~OCUPADO~': 'Ocupado',
    '~SEGUNDOS~': 'Segundos',
    '~SEGUNDOS_MIN~': 'Seg',
    '~MINUTOS~': 'Minutos',
    '~MINUTOS_MIN~': 'Min',
    '~NUMERO_INVALIDO~': 'Número Inválido',
    '~NO_REPICO~': 'Não tocou',
    '~NO_CONTESTO~': 'Não Atendeu',
    '~PROMEDIO_CONTESTO~': 'Porcentagem Atendidas',
    '~DETALLES_INTENTOS~': 'Detalhes por Tentativas',
    '~INTENTOS~': 'Tentativa',
    '~DISPOSICION~': 'Disposição',
    '~NUMEROS~': 'Números',
    '~CODIGO_ISDN~': 'Código ISDN',
    '~PRIMERO~': 'Primeiro',
    '~ULTIMO~': 'Último',
    '~NO_REPORTE~': 'Não existem bases de dados registradas',
    '~NO_DATA~': 'Não há dados suficientes',
    '~DESCARGAR~': 'Descarregar Relatórios',
    '~SUMAR_REPORTES~': 'Somar Relatórios',
    '~REPORTE_COMPLETO~': 'Relatório Completo',
    '~SUMADAS~': 'Somas',
    '~TITULO_SELECCION~': 'Selecione as campanhas que deseja adicionar ao relatório'
  },
  users: {
    '~EDITAR~': 'Editar Usuário',
    '~INSERTAR~': 'Novo Usuário',
    '~NO_USUARIOS~': 'Não existen usuários registrados',
    '~AGREGAR~': 'Adicionar Usuário',
    '~TITULO~': 'Lista de Usuários',
    '~NOMBRE~': 'Nome',
    '~APELLIDO~': 'Sobrenome',
    '~CORREO~': 'Correio',
    '~CLAVE~': 'Senha',
    '~TELEFONO~': 'Telefone',
    '~CELULAR~': 'Celular',
    '~POSICION~': 'Posição',
    '~ID_TARJETA~': 'Cartão',
    '~ACTIVO~': 'Ativo',
    '~INACTIVO~': 'Inativo',
    '~ROL~': 'Funções',
    '~ORGANIZACIONES~': 'Organizações',
    '~ROLES_TODAS~': 'Atualizar funções em todas as organizações',
    '~ROLES_ACTUAL~': 'Atualizar funções somente para',
    '~ACTUALIZAR_ORGS~': 'Atualizar organizações para a qual pertence o usuário',
    '~BUSCAR~': 'Buscar...',
    '~ETIQUETA_SELECCION~': 'Digite enter para selecionar'
  },
  file: {
    '~NOMBRE~': 'Nome',
    '~NOMBRE_AMIGABLE~': 'Nome Amigável',
    '~SUBIR~': 'Subir Arquivo',
    '~ACEPTABLE~': 'Tipo de arquivo "aceitável" : CSV',
    '~PERMANENTE~': 'Permanente',
    '~DESCARGAR~': 'Descarregar Relatório'
  },
  audio: {
    '~AGREGAR~': 'Agregar Áudio',
    '~BORRAR~': 'Apagar',
    '~SELECCION~': 'Selecionar Áudio',
    '~REPRODUCIR~': 'Reproduzir',
    '~REPRODUCIENDO~': 'Reproduzindo',
    '~DETENER~': 'Parar',
    '~PAUSAR~': 'Pausar',
    '~GUARDANDO~': 'Salvando áudios',
    '~CONTINUAR~': 'Continuar',
    '~VOZ~': 'Voz',
    '~NOMBRE~': 'Nome do Áudio',
    '~ARCHIVO~': 'Arquivo de Áudio',
    '~NO_AUDIO~': 'Não teve resultados'
  },
  action: {
    '~NOMBRE~': 'Ação',
    options: {
      '~COLGAR~': 'Desligar',
      '~RETORNAR~': 'Retornar',
      '~EMPEZAR~': 'Começar',
      '~REPETIR~': 'Repetir'
    }
  },
  step: {
    '~NOMBRE~': 'Passo',
    '~GUARDAR~': 'Guardar passo',
    options: {
      '~TTS~': 'TTS',
      '~PLAYBACK~': 'Reproduzir',
      '~RECORD~': 'Gravar',
      '~RECORD_DIGITS~': 'Gravar Dígitos',
      '~TRANSFERIR~': 'Transferir',
      '~VARIABLE_WEB~': 'Variável Web',
      '~COLGAR~': 'Desligar',
      '~RETORNAR~': 'Retornar',
      '~EMPEZAR~': 'Começar',
      '~REPETIR~': 'Repetir',
      '~ASR~': 'ASR',
      '~DELAY~': 'DEMORA'
    }
  },
  transition: {
    '~NOMBRE~': 'Transição',
    options: {
      '~DIGITOS~': 'Dígitos',
      '~SIGUIENTE~': 'Seguinte',
      '~ASR~': 'ASR',
      '~VARCOMP~': 'Varcomp',
      '~NINGUNO~': 'Nenhum'
    }
  },
  tour: {
    admin: {
      '~NAVEGACION~':
        '<strong>¡Bem-vindo à IPCOM!</strong><br /><br />Fornecemos a você ferramentas de alta tecnología para lhe ajudar a tomar as melhores decisões.<br /><br />No seguinte tour você poderá conhecer a forma mais fácil de utilizar o nosso sistema fazendo click em  <strong>Seguinte</strong>',
      '~MENU~':
        'Selecione as opções do menu de forma "direta" : <strong>Painel</strong> para as campanhas ativas, <strong>Organizações</strong> que difundem as campanhas, <strong>Bases de Dados</strong> dos seus filiados, geração de <strong>Campanhas</strong> e <strong>Usuários</strong> autorizados para criá-las.',
      '~USER_CARD~': 'Indica o perfil do usuário ativo para usar o sistema <strong>IPCOM</strong>',
      '~SALIR~': 'Botão para fechar sessão.',
      '~LISTA_ORG~':
        'Lista de seleção, use-a para trocar a organização atual, desde a qual se gerarão as campanhas e configurações no sistema',
      '~MENU_TABLERO~':
        '<strong>Painel</strong><br /><br />Apresenta as campanhas ativas em tempo real, as últimas campanhas processadas, a base de dados de filiados, e os áudios TTS gerados em cada campanha.',
      '~MENU_ORGANIZACION~':
        '<strong>Organização</strong><br /><br />Mostra as organizações clientes e permite registrar novas organizações, editá-las e eliminá-las.',
      '~MENU_BASEDATOS~':
        '<strong>Bases de Dados</strong><br /><br />Permite ver, administrar e gerar bases de dados de subscritos utilizadas no momento de criar una campanha.',
      '~MENU_CAMPANA~':
        '<strong>Campanhas</strong><br /><br />Permite ver, criar, administrar e configurar campanhas. Supervisa a hora exata e data de geração de cada campanha. Revisa e descarrega relatórios.',
      '~MENU_USERS~':
        '<strong>Usuários</strong><br /><br />Usuários registrados e autorizados para criar, supervisar, editar e configurar campanhas, bases de dados, etc, segundo a função e o nível de acesso concedidos.',
      '~BARRA~': 'Barra superior, contem a página de navegação atual e algumas ferramentas.',
      '~IDIOMA~': 'Seleção de idioma.',
      '~MENU_IDIOMA~': 'Opções de Idioma.',
      '~AYUDA~': 'Ativar ou desativar ajudas visuais.',
      '~ACTIVAS~': 'Neste painel mostra-se os detalhes e especificações das campanhas ativas em tempo real.',
      '~CAMPANAS~': 'Neste painel encontram-se as últimas campanhas, ativas e/ou modificadas.',
      '~SUBSCRIBERS~': 'Neste painel enumeram-se as bases de dados de subscritos mais recentes criadas ou modificadas.',
      '~TTS_AUDIOS~':
        'Neste painel mostra-se os arquivos TTS (Tech To Speech) gerados em tempo real, utilizados pela organização em campanhas ativas e antigas.',
      organization: {
        '~INTRO~':
          'Vista geral das organizações registradas em IPCOM com seus dados configurados segundo a empresa; além das opções para adicionar novas e editar ou eliminar as já existentes.',
        '~BUSCADOR~': 'Escreve o nome da organização que deseja procurar',
        '~INSERTAR~': 'Registra novas organizações no sistema.',
        '~TABLA~':
          'Cada fila mostra o ID da organização no sistema e o nome legal. Também pode editar ou eliminar organizações já registradas.',
        '~ACCIONES~': 'Ações para a gestão da organização respectiva.',
        '~EDITAR~': 'Edite dados da organização respectivamente.',
        '~ELIMINAR~': 'Eliminar a organização do sistema depois da confirmação'
      },
      subscriber: {
        '~INTRO~':
          'Seleciona uma base de dados já carregada no sistema ou adiciona novas bases de dados para a sua campanha. <br /><br />Você pode editar ou eliminar o banco de dados que requerer, se for necessário.',
        '~BUSCADOR~': 'Escreve o nome da base de dados que deseja buscar',
        '~INSERTAR~': 'Carrega novas bases de dados ao sistema.',
        '~TABLA~':
          'Cada fila reflete o nome da base de dados, data de criação, número de subscritos e colunas utilizadas na campanha.',
        '~ACCIONES~': 'Ações para a gestão da base de dados respectiva.',
        '~EDITAR~': 'Editar a configuração desta base de dados.',
        '~ELIMINAR~': 'Eliminar esta base de dados depois de confirmar.',
        uploadform: {
          '~FORMULARIO~':
            '<strong>Formulário de Arquivo</strong><br /><br /> O arquivo CSV (comma-separated values) utiliza-se para o intercâmbio de dados em forma de coluna de uma planilha de cálculo.<br /><br /> Adicione o nome e carregue o arquivo CSV que salvou no seu dispositivo.',
          '~ARCHIVO~': 'Click para selecionar o arquivo CSV desde o seu dispositivo.',
          '~CANCELAR~': 'Cancelar e retornar à tela anterior.',
          '~ENVIAR~': 'Enviar formulário e ir ao passo seguinte.'
        },
        import: {
          '~FORMULARIO~':
            '<strong>Importar Contatos</strong><br /><br /> Antes de importar a base de dados, configure os nomes das variáveis contidas no arquivo CSV carregado anteriormente.',
          '~GRUPO~': 'Cada quadro representa uma coluna do arquivo CSV carregado anteriormente.',
          '~COLUMNAS~':
            'Este quadro mostra o nome da coluna, parte do seu conteúdo e opções de configuração para editar ou omitir a variável.',
          '~EDITAR~': 'Faça click se deseja modificar o nome da coluna.',
          '~OMITIR~': 'Fala click se deseja Omitir esta coluna da base de dados.',
          '~CABECERAS~': 'Permite descartar a primeira fila ou cabeçalho do arquivo CSV carregado anteriormente.',
          '~CANCELAR~': 'Cancelar e ir ao menu anterior.',
          '~GUARDAR~': 'Salvar todas as mudanças e gerar a nova Base de Dados de subscritos.'
        }
      },
      campaign: {
        '~INTRO~':
          'Revisa, administra e configura antigas e novas campanhas. <br /><br />Supervisa a hora exata e data de geração das campanhas. Revisa e descarrega relatórios.',
        '~BUSCADOR~': 'Escreve o nome da campanha que deseja buscar.',
        '~INSERTAR~': 'Configura uma nova campanha desde zero.',
        '~TABLA~':
          'Cada  fila apresenta o nome de uma campanha no sistema, seu status, data e hora de criação e ações para sua configuração.',
        '~ACCIONES~': 'Ações para a gestão da campanha respectiva.',
        '~EDITAR~': 'Edita todos os dados e configuração da campanha.',
        '~COPIAR~': 'Cria novas campanhas utilizando ou clonando o conteúdo desta campanha.',
        '~REPORTES~': 'Procura dados, estatísticas e informação relevante da campanha.',
        '~DESCARGAS~': 'Descarrega o relatório da campanha num arquivo CSV.',
        '~ARCHIVAR~': 'Arquiva o relatório da campanha.',
        '~CPS_MÁXIMO_ERROR~': 'O valor atribuído ao CPS ultrapassa o máximo estabelecido dentro da organização. CPS máximo: {cps}.',
        steps: {
          '~COFIGURACION~':
            '<strong>Configuração</strong><br /><br />Escreve corretamente os dados solicitados em cada um dos campos de registro da configuração. <br /><br />Esses dados determinam o valor das variáveis na campanha que vai se adicionar.',
          '~BASEDATOS~':
            'Seleciona uma base de dados já carregada no sistema e adiciona novas bases de dados para sua campanha. <br /><br />Você pode editar ou eliminar o banco de dados que requerir, se for necessário.',
          '~DIAPLAN~':
            'Cria a Campanha que deseja mediante um sistema de passos.<br /><br /> O Dialplan  organiza-se por passos e transições.',
          '~ENVIAR~':
            'Antes de enviar, verifica que os dados, arquivos, áudios e solicitações realizadas tenham sido carregados corretamente.',
          '~NAVEGADOR~':
            'Navegue através desta barra (breadcrumbs), para encontrar a forma de retornar ao passo anterior.',
          '~SELECTOR~': 'Selecione desta lista o tipo de passo que lhe permita configurar corretamente o Dialplan.',
          '~ACTUAL~':
            'Nesta área configura-se o passo atual.<br /><br /> Complete os dados corretamente segundo o tipo de passo selecionado para o Dialplan.',
          '~TRANSICION~': 'A transição permite conectar novos passos na campanha segundo a configuração que precise',
          '~ARBOL~':
            'Permite conhecer os passos utilizados durante a configuração de cada campanha.<br /><br /> Pode selecionar qualquer passo que deseje editar.',
          '~PASO_ACTUAL~': 'O resultado em azul significa o passo que se está editando atualmente.',
          '~PANEL_CONFIG~': 'Resumo dos dados da configuração no passo 1.',
          '~PANEL_DATABASE~': 'Informação da base de dados de subscritos que se usará na campanha.',
          '~PANEL_DIALPLAN~': 'Árvore de passos que mostra o plano de discagem previamente configurado.',
          '~ENVIAR_FINAL~': 'Click aquí em Enviar, uma vez esteja de acordo com a informação aquí mostrada.',
          '~SINTETIZAR~':
            'Em caso de que dentro do seu plano de discagem existam áudios que se têm que gerar, deverá primeiro fazer click aquí para gerá-los.'
        }
      },
      user: {
        '~INTRO~':
          'Conheça os principais dados dos usuários registrados e autorizados pela sua organização para administrar e configurar o sistema.',
        '~BUSCADOR~': 'Explora usuários por nome, sobrenome, número telefônico ou correio electrônico.',
        '~INSERTAR~': 'Registrar um novo usuário no sistema.',
        '~TABLA~':
          'Cada fila mostra nomes e sobrenomes do usuário, número de telefone, email, função no sistema, número de cartão e status de actividade.',
        '~ACCIONES~': 'Ações para a gestão de um usuário respectivo.',
        '~ACIVAR~': 'Ativar e desativar usuário.',
        '~EDITAR~': 'Edite dados de usuário respectivamente.',
        '~ELIMINAR~': 'Eliminar usuário do sistema depois da confirmação'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/pt.js